import { render, staticRenderFns } from "./afterPurchaseSet.vue?vue&type=template&id=7970f4d9&scoped=true&"
import script from "./afterPurchaseSet.vue?vue&type=script&lang=js&"
export * from "./afterPurchaseSet.vue?vue&type=script&lang=js&"
import style0 from "./afterPurchaseSet.vue?vue&type=style&index=0&id=7970f4d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7970f4d9",
  null
  
)

component.options.__file = "afterPurchaseSet.vue"
export default component.exports